<template>
  <div>
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="el-icon-s-home"></i>
        </el-breadcrumb-item>
        <el-breadcrumb-item>用户中心</el-breadcrumb-item>
        <el-breadcrumb-item>订单详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="wrapper">
      <div class="sidebar">
        <div class="avatar">
          <img src="../../assets/images/avatar.jpg" />
          <div class="name">
            <!--<h3>张明翰</h3>-->
            <p>{{ phoneNumShow() }}</p>
          </div>
        </div>
        <ul class="menu">
          <li class="active">
            <router-link to="/account/ticket-order">
              <img src="../../assets/images/icon-order-active.png" />
              <span>票务订单</span>
            </router-link>
          </li>
          <li>
            <router-link to="/account/mall-order">
              <img src="../../assets/images/icon-order.png" />
              <span>商城订单</span>
            </router-link>
          </li>
          <li>
            <router-link to="/account/contacts">
              <img src="../../assets/images/icon-contacts.png" />
              <span>常用联系人</span>
            </router-link>
          </li>
          <!--
          <li>
            <router-link to="/account/profile">
              <img src="../../assets/images/icon-profile.png" />
              <span>个人资料</span>
            </router-link>
          </li>-->
        </ul>
      </div>
      <div class="main">
        <div class="order-title">
          <h2>订单详情</h2>
          <!--<router-link to="./">&lt; 返回列表</router-link>-->
          <a @click="goOrderList">&lt; 返回列表</a>
        </div>
        <div class="order-detail">
          <div class="info">
            <div class="time">
              <h3>入园时间 {{ orderDate }}</h3>
              <p>
                数量<span v-if="orderDetailInfo.users_info">{{
                  orderDetailInfo.users_info.length
                }}</span>
              </p>
            </div>
            <div class="number">
              <div>
                <p>下单时间：{{ orderDetailInfo.create_time }}</p>
                <p>订单编号：{{ orderDetailInfo.order_sn }}</p>
              </div>
              <div class="price">
                ¥<span>{{ orderDetailInfo.goods_amount }}</span>
              </div>
            </div>
            <div class="status">
              <div>
                <p class="completed" v-if="orderDetailInfo.status == 0">
                  <img src="../../assets/images/icon-completed.png" /> 已完成
                </p>
                <p class="cancelled" v-if="orderDetailInfo.status == 4">
                  <img src="../../assets/images/icon-cancelled.png" /> 已取消
                </p>
                <p class="cancelled" v-if="orderDetailInfo.status == 9">
                  <img src="../../assets/images/icon-cancelled.png" /> 等待退款
                </p>
                <p class="cancelled" v-if="orderDetailInfo.status == 10">
                  <img src="../../assets/images/icon-cancelled.png" /> 已退款
                </p>
                <p class="cancelled" v-if="orderDetailInfo.status == 12">
                  <img src="../../assets/images/icon-cancelled.png" /> 部分退款
                </p>
                <p class="cancelled" v-if="orderDetailInfo.status == 14">
                  <img src="../../assets/images/icon-cancelled.png" /> 退款中
                </p>
                <p class="unpaid" v-if="orderDetailInfo.status == 1">
                  <img src="../../assets/images/icon-unpaid.png" /> 待支付
                </p>
              </div>
              <span
                class="button"
                v-if="orderDetailInfo.status == 1"
                @click="cancelOrder(orderDetailInfo.order_sn)"
                >取消订单</span
              >
              <span
                class="button"
                v-if="orderDetailInfo.status == 0"
                @click="refundOrder(orderDetailInfo.order_sn)"
                >整单退</span
              >
            </div>
          </div>
          <ul class="tourist-list">
            <li v-for="(userInfo, uindex) in newUserListArray" :key="uindex">
              <div class="left">
                <h3>
                  {{ userInfo.customer_name
                  }}<span>{{ userInfo.customer_type }}</span>
                </h3>
                <p>
                  {{ IDTypeName(userInfo.id_type) }}：{{ userInfo.id_number }}
                </p>
              </div>
              <div v-if="userInfo.ticket_coupon == 0">
                <div
                  class="center"
                  v-for="(ticketInfo, tindex) in userInfo.tickets"
                  :key="tindex"
                >
                  <div>
                    <span>{{ ticketInfo.config_name }}</span>
                    <span v-if="ticketInfo.is_show_price">
                      ¥ {{ ticketInfo.real_price }}
                    </span>
                  </div>
                  <div
                    class="qrGet"
                    v-if="
                      (orderDetailInfo.status == 0 ||
                        orderDetailInfo.status == 12 ||
                        orderDetailInfo.status == 13) &&
                        userInfo.ticket_coupon == 0 &&
                        getDayByNow(ticketInfo.valid_time)
                    "
                  >
                    <!-- <span>手机号：</span> -->
                    <input
                      class="text-input"
                      v-model="userInfo.newPhone"
                      placeholder="请输入接收二维码的手机号"
                    />
                    <button
                      class="link"
                      :disabled="userInfo.btnChangeEnable"
                      @click="goPhoneMessage(ticketInfo, uindex)"
                    >
                      {{ userInfo.codeText }}
                    </button>
                  </div>
                </div>
              </div>
              <div class="center" v-if="userInfo.ticket_coupon == 1">
                <div>
                  <span>{{ userInfo.tickets[0].config_name }}</span>
                  <span v-if="userInfo.tickets[0].is_show_price">
                    ¥ {{ userInfo.tickets[0].real_price }}
                  </span>
                  <span
                    >（{{ getTicketGroupName(userInfo.real_ticket_configs)
                    }}{{
                      getTicketGroupPrice(userInfo.real_ticket_configs)
                    }}）</span
                  >
                </div>
                <div
                  class="qrGet"
                  v-if="
                    (orderDetailInfo.status == 0 ||
                      orderDetailInfo.status == 12 ||
                      orderDetailInfo.status == 13) &&
                      getDayByNow(userInfo.tickets[0].valid_time)
                  "
                >
                  <!-- <span>手机号：</span> -->
                  <input
                    class="text-input"
                    v-model="userInfo.newPhone"
                    placeholder="请输入接收二维码的手机号"
                  />
                  <button
                    class="link"
                    :disabled="userInfo.btnChangeEnable"
                    @click="goPhoneMessage(userInfo.tickets[0], uindex)"
                  >
                    {{ userInfo.codeText }}
                  </button>
                </div>
              </div>
              <div class="right">
                <p>{{ ticketStatusDesc(userInfo.tickets[0].status) }}</p>
                <span
                  class="button"
                  v-if="
                    userInfo.tickets[0].status == 2 &&
                      showRefundLayout(userInfo)
                  "
                  @click="refundButton(userInfo)"
                  >退票</span
                >
              </div>
            </li>
          </ul>
        </div>
        <div class="unpaid-bar" v-if="orderDetailInfo.status == 1">
          <p>
            待支付：<span>¥{{ orderDetailInfo.goods_amount }}</span>
          </p>
          <span class="button" @click="goPay(orderDetailInfo.goods_amount)"
            >立即支付</span
          >
        </div>
      </div>
    </div>
    <new-pay-pouup
      :payDialogShow="payQrCode"
      :orderId="orderDetailInfo.order_sn"
      :orderAmount="orderDetailInfo.goods_amount"
      v-on:payPrenterShow="payPrenterShow"
    ></new-pay-pouup>
    <el-dialog
      title="取消订单提示"
      :visible.sync="cancelDialogVisible"
      width="30%"
      :before-close="cancelDialogHidden"
    >
      <p>您确定要取消该订单么？</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="cancelOrderConfirm">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="退订单提示"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="refundOrderDialogHidden"
    >
      <p>您确定要退掉吗？退票以后，该票将无法使用，票款将原路退回</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="refundOrderConfirm">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="退票提示"
      :visible.sync="refundTicketDialogVisible"
      width="30%"
      :before-close="refundTicketDialogHidden"
    >
      <p v-if="refundFeeSum > 0">
        本次退票要收取退票服务费: {{ refundFeeSum }}元\n确定要退{{
          ticketName
        }}吗?
      </p>
      <p v-if="refundFeeSum <= 0">确定要退{{ ticketName }}吗?</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="refundTicketDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="refundTicketConfirm">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { isArray, getTicketStatusDesc, getDayByNow } from '@/setup/common';
import order from '@/api/order';
import info from '@/api/info';
import constValuesConfig from '@/setup/constantConfig';
import routerTo from '@/router/routerTo';
import { phoneHidden, regexs } from '@/setup/common';
import user from '@/setup/user';
import NewPayPouup from '@/components/NewPayPouup';
import base from '@/api/base';
export default {
  components: {
    NewPayPouup,
  },
  data() {
    return {
      payQrCode: false, //支付二维码弹框
      orderId: '',
      orderDetailInfo: {},
      usersInfo: [],
      usersSingleInfo: {}, //单个游客的票信息
      is_union: 0,
      newUserListArray: [],
      certificateTypeList: constValuesConfig.ID,
      orderDate: '',
      cancelDialogVisible: false,
      dialogVisible: false,
      refundTicketDialogVisible: false,
      refundFeeSum: 0,
      ticketName: '',
      singleUnionCode: '',
      btnChangeEnable: false,
      intervalId: null,
      /*codeText: '发送二维码',*/
    };
  },
  computed: {},
  created() {
    let query = this.$route.query;
    this.orderId = query.orderId;
    this.orderDate = query.orderDate;
    /*let currentUser = user.getUser();
    if (currentUser != null) {
      this.loginPhone = currentUser.phone;
    }*/
    this.fetchOrderInfo();
  },
  methods: {
    getDayByNow(timeStr) {
      //判断入园时间是否是今天或者今天以后
      return getDayByNow(timeStr);
    },
    payQrCodeFn() {
      this.payQrCode = !this.payQrCode;
    },
    payPrenterShow(orderItem) {
      this.payQrCode = false;
      this.$router.go(-1);
    },
    goPay(amount) {
      if (parseFloat(amount) == 0) {
        this.payQrCode = false;
        this.payOrderZero();
      } else {
        this.payQrCode = true;
      }
    },
    async payOrderZero() {
      let that = this;
      const payOrderZeroGet = await order.payOrderZero({
        product_code: process.env.VUE_APP_TICKET_PRODUCT_CODE, //TODO
        order_code: this.orderId,
        pay_channel: 'PO_CASH',
        /*channel_id: '10009'*/
      });
      this.payPrenterShow();
    },
    goOrderList() {
      /*routerTo.toOrderList(this.$router, false);*/
      this.$router.go(-1);
    },
    cancelDialogHidden() {
      this.cancelDialogVisible = false;
    },
    refundOrderDialogHidden() {
      this.dialogVisible = false;
    },
    async goPhoneMessage(ticket, getIndex) {
      console.log('这是啥', this.newUserListArray, getIndex);
      this.loginPhone = this.newUserListArray[getIndex].newPhone;
      /*let timeInterval = this.newUserListArray[getIndex].timeInterval;*/
      if (!this.loginPhone) {
        alert('请输入手机号');
        return;
      }
      if (!regexs.allphone.test(this.loginPhone)) {
        alert('请输入正确的手机号');
        return;
      }
      const phoneMessage = await base.getQuerySendmsg({
        site: process.env.VUE_APP_PLACE_CODE,
        phone: this.loginPhone,
        ticket_code: ticket.ticket_code,
      });
      this.countDown(getIndex);
    },
    countDown(getIndex) {
      let num = 90;
      this.intervalId = setInterval(() => {
        if (num) {
          num--;
          /*this.codeText = JSON.stringify(num);*/
          this.newUserListArray[getIndex].codeText = JSON.stringify(num);
          this.newUserListArray[getIndex].btnChangeEnable = true;
          //this.btnChangeEnable = true;
        } else {
          num = 90;
          clearInterval(this.intervalId);
          /*this.codeText = '发送二维码';*/
          this.newUserListArray[getIndex].codeText = '发送二维码';
          this.newUserListArray[getIndex].btnChangeEnable = false;
          //this.btnChangeEnable = false;
        }
      }, 1000);
    },
    refundTicketDialogHidden() {
      this.refundTicketDialogVisible = false;
    },
    async fetchOrderInfo() {
      const orderDetailGet = await order.orderDetail({
        order_id: this.orderId,
      });
      this.orderDetailInfo = orderDetailGet;
      this.is_union = orderDetailGet.is_union;
      this.usersInfo = orderDetailGet.users_info;
      this.userListSwitch();
    },
    IDTypeName(idType) {
      let idName = '';
      this.certificateTypeList.forEach((item) => {
        if (item.value == idType) {
          idName = item.name;
        }
      });
      return idName;
    },
    userListSwitch: function() {
      let arr1 = [];
      let obj = {};
      console.log('000000000000');
      console.log(this.usersInfo);
      console.log(this.usersInfo.length);
      let len = this.usersInfo.length;
      // 联票处理
      if (this.isGroup) {
        for (let i = 0; i < len; i++) {
          let union_code = this.usersInfo[i].union_info.union_code;
          if (!obj[union_code]) {
            let objItem = {
              customer_name: this.usersInfo[i].customer_name,
              customer_type: this.usersInfo[i].customer_type,
              id_type: this.usersInfo[i].id_type,
              id_number: this.usersInfo[i].id_number,
              user_channel: this.usersInfo[i].user_channel,
              union_code: union_code,
              real_price: this.usersInfo[i].union_info.real_price,
              config_name: this.usersInfo[i].union_info.config_name,
              tickets: [this.usersInfo[i]],
            };
            arr1.push(objItem);
            obj[union_code] = 1;
          } else {
            console.log(arr1);
            for (let s = 0, lens = arr1.length; s < lens; s++) {
              if (arr1[s].union_code === union_code) {
                arr1[s].tickets.push(this.usersInfo[i]);
              }
            }
          }
        }
        this.newUserListArray = arr1;
      } else {
        this.newUserListArray = this.usersInfo;
      }
      this.newUserListArray.forEach((newItem) => {
        this.$set(newItem, 'newPhone', '');
        this.$set(newItem, 'codeText', '发送二维码');
        this.$set(newItem, 'btnChangeEnable', false);
      });
      console.log('222222', JSON.stringify(this.newUserListArray));
    },
    //获取门票名称组合
    getTicketGroupName(valItem) {
      if (!Array.isArray(valItem)) {
        return '';
      }
      let ticket_configs = [];
      if (this.is_union) {
        for (let i = 0; i < valItem.length; i++) {
          for (let s = 0; s < valItem[i].tickets.length; s++) {
            ticket_configs.push(valItem[i].tickets[s].config_name);
          }
        }
        if (ticket_configs.length > 0) {
          return '含' + ticket_configs.join(' + ');
        }
      } else {
        for (let i = 0; i < valItem.length; i++) {
          ticket_configs.push(valItem[i].config_name);
        }
        if (ticket_configs.length > 0) {
          return '含' + ticket_configs.join(' + ');
        }
      }
      return '';
    },
    ticketStatusDesc(status) {
      return getTicketStatusDesc(status);
    },
    cancelOrder(orderCode) {
      this.cancelDialogVisible = true;
      this.orderId = orderCode;
    },
    refundOrder(orderCode) {
      this.dialogVisible = true;
      this.order_id = orderCode;
    },
    async cancelOrderConfirm() {
      //取消订单确认
      const cancelOrder = await order.orderCancel({
        order_id: this.orderId,
      });
      this.cancelDialogVisible = false;
      this.fetchOrderInfo();
    },
    async refundOrderConfirm() {
      await order.orderRefund({
        order_code: this.order_id,
      });
      this.dialogVisible = false;
      this.fetchOrderInfo();
    },
    async refundTicketConfirm() {
      //退单个票TODO
      const ticketsRefundGet = await info.getTicketsRefund({
        ticket_id: this.singleUnionCode,
      });
      this.refundTicketDialogVisible = false;
      this.fetchOrderInfo();
    },
    async refundButton(singleInfo) {
      //退单票TODO
      this.usersSingleInfo = singleInfo;
      this.refundTicketDialogVisible = true;
      let unUseCount = 0;
      let ticketInfo = {};
      // 是否单票尾部退票按钮
      if (
        this.usersSingleInfo.ticketsStatus == 2 ||
        this.usersSingleInfo.tickets[0].status == 2
      ) {
        unUseCount++;
      } else {
        unUseCount = 0;
      }
      if (unUseCount) {
        ticketInfo = this.usersSingleInfo;
      } else {
        return;
      }
      let union_code = '';
      if (this.is_union) {
        union_code = ticketInfo.tickets[0].union_code;
      } else {
        // 判断是多张单票还是单张票
        if (this.usersSingleInfo.ticketsStatus == 2) {
          let arr = [];
          for (let i = 0; i < ticketInfo.tickets.length; i++) {
            arr.push(ticketInfo.tickets[i].union_code);
          }
          union_code = arr.join('_');
        } else {
          union_code = this.usersSingleInfo.union_code;
        }
      }
      if (unUseCount) {
        const orderDetailGet = await order.orderDetail({
          order_id: this.orderId,
        });
        let refund_fee_sum = 0;
        let users_info = orderDetailGet.users_info;
        let len = users_info.length;
        for (let i = 0; i < len; i++) {
          if (union_code.search(users_info[i].union_code) != -1) {
            let tickets = users_info[i].tickets;
            let lens = tickets.length;
            for (let s = 0; s < lens; s++) {
              refund_fee_sum += tickets[s].refund_fee * 100;
            }
          }
        }
        refund_fee_sum = refund_fee_sum / 100;
        let place_name = ticketInfo.tickets[0].config_name;
        let ticket_name = this.is_union
          ? ticketInfo.tickets[0].union_info.config_name
          : place_name;
        this.refundFeeSum = refund_fee_sum;
        this.ticketName = ticket_name;
        this.singleUnionCode = union_code;
      }
    },
    phoneNumShow() {
      let currentUser = user.getUser();
      if (currentUser != null) {
        let phone = phoneHidden(currentUser.phone);
        return phone;
      }
    },
    //获取门票价格组合
    getTicketGroupPrice: function(valItem) {
      if (!Array.isArray(valItem)) {
        return '';
      }
      let ticket_configs = [];
      if (this.is_union) {
        for (let i = 0; i < valItem.length; i++) {
          for (let s = 0; s < valItem[i].tickets.length; s++) {
            if (valItem[i].tickets[s].is_show_price) {
              ticket_configs.push(valItem[i].tickets[s].real_price);
            }
          }
        }
        if (ticket_configs.length > 0) {
          return '￥' + '(' + ticket_configs.join(' + ') + ')';
        }
      } else {
        for (let i = 0; i < valItem.length; i++) {
          if (valItem[i].is_show_price) {
            ticket_configs.push(valItem[i].real_price);
          }
        }
        if (ticket_configs.length > 0) {
          return '￥' + '(' + ticket_configs.join(' + ') + ')';
        }
      }
      return '';
    },
    showRefundLayout(userSingleInfo) {
      let can_refund = Object.prototype.hasOwnProperty.call(
        localStorage,
        'can_refund',
      )
        ? localStorage.getItem('can_refund')
        : 0;
      console.log('==> can_refund = ' + can_refund);
      if (can_refund != 1) {
        return false;
      }
      let unUsedCount = 0;
      for (var i = 0; i < userSingleInfo.tickets.length; i++) {
        let status = userSingleInfo.tickets[i].status;
        if (status == 2) {
          unUsedCount++;
        }
      }
      return unUsedCount > 0;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.wrapper {
  display: flex;
  justify-content: space-between;
  width: 1100px;
  margin: 0 auto;
  padding: 20px 0;
  text-align: left;
}
.sidebar {
  width: 280px;
  padding: 20px 0;
  border-radius: 10px;
  background: #fff;
  .avatar {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    padding: 0 30px;
    .name {
      margin-left: 16px;
      h3 {
        margin-bottom: 5px;
        font-size: 18px;
      }
    }
  }
  .menu {
    li {
      height: 50px;
      padding: 0 0 0 30px;
      font-size: 16px;
      line-height: 50px;
      a {
        display: block;
        color: #191b26;
      }
      img {
        width: 24px;
        height: 24px;
        margin-right: 10px;
      }
    }
    li.active {
      border-right: 2px solid #31a775;
      color: #31a775;
      background: #f6fcf9;
      a {
        color: #31a775;
      }
    }
  }
}
.main {
  width: 800px;
  .order-title {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    border-bottom: 1px solid #eee;
    line-height: 40px;
    h2 {
      border-bottom: 2px solid #31a775;
      color: #31a775;
      font-weight: normal;
      font-size: 16px;
    }
    a {
      color: #31a775;
      font-size: 16px;
      cursor: pointer;
    }
  }
  .order-detail {
    border-radius: 10px;
    line-height: 24px;
    background: #fff;
    .info {
      padding: 20px 20px;
      .time {
        display: flex;
        justify-content: space-between;
        margin-bottom: 6px;
        h3 {
          color: #191b26;
          font-size: 16px;
        }
        p span {
          margin-left: 6px;
          font-size: 20px;
        }
      }
      .number {
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        color: #515457;
        .price {
          padding-bottom: 10px;
          span {
            margin-left: 6px;
            color: #f15b49;
            font-size: 20px;
          }
        }
      }
      .status {
        display: flex;
        align-items: center;
        justify-content: space-between;
        a {
          margin-left: 10px;
        }
        .button {
          display: inline-block;
          min-width: 90px;
          padding: 6px 16px;
          border-radius: 18px;
          color: #fff;
          text-align: center;
          background: #31a775;
          cursor: pointer;
        }
        .completed {
          color: #31a775;
        }
        .unpaid {
          color: #f15b49;
        }
        .cancelled {
          color: #9e9e9e;
        }
        img {
          width: 20px;
          height: 20px;
          margin-right: 2px;
        }
      }
    }
    .tourist-list {
      padding: 20px 20px;
      border-top: 1px solid #eee;
      li {
        display: flex;
        justify-content: space-between;
        margin-bottom: 15px;
        padding-bottom: 15px;
        border-bottom: 1px dashed #eee;
        line-height: 30px;
        .left {
          width: 220px;
          h3 {
            color: #191b26;
            font-size: 16px;
          }
          span {
            display: inline-block;
            margin-left: 20px;
            padding: 2px 10px 2px;
            border: 1px solid #31a775;
            border-radius: 14px;
            color: #31a775;
            font-weight: normal;
            font-size: 14px;
            line-height: 20px;
          }
        }
        .center {
          display: flex;
          flex-direction: column;
          width: 390px;
          text-align: center;
        }
        .qrGet {
          display: flex;
          flex-direction: row;
          justify-content: center;
          .text-input {
            width: 200px;
            height: 27px;
            padding: 0 8px;
            border: 1px solid #dcdfe6;
            font-size: 14px;
            outline: none;
          }
          .link {
            width: 90px;
            margin-left: 10px;
            border: none;
            color: #31a775;
            cursor: pointer;
          }
        }
        .right {
          width: 90px;
          margin-left: 60px;
          color: #9e9e9e;
          text-align: center;
          .button {
            display: inline-block;
            width: 90px;
            padding: 6px 16px;
            border-radius: 18px;
            color: #fff;
            line-height: 24px;
            text-align: center;
            background: #31a775;
            cursor: pointer;
          }
        }
      }
    }
  }
  .unpaid-bar {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 10px;
    padding: 20px 20px;
    border-radius: 10px;
    background: #fff;
    p {
      font-size: 16px;
      span {
        color: #f15b49;
        font-weight: bold;
      }
    }
    .button {
      display: inline-block;
      width: 88px;
      margin-left: 40px;
      padding: 6px 16px;
      border-radius: 18px;
      color: #fff;
      line-height: 24px;
      text-align: center;
      background: #31a775;
      cursor: pointer;
    }
  }
}
.main /deep/ .el-tabs__header {
  margin: 0 0 20px;
}
.main /deep/ .el-tabs__item {
  height: 40px;
  border: none;
  color: #515457;
  font-size: 16px;
  line-height: 40px;
}
.main /deep/ .el-tabs__item.is-active {
  color: #31a775;
}
.main /deep/ .el-tabs__item:hover {
  color: #31a775;
}
.main /deep/ .el-tabs__active-bar {
  height: 2px;
  background: #31a775;
}
.main /deep/ .el-tabs__nav-wrap::after {
  height: 1px;
}
</style>
